import {setFullHeight} from "../menu/search";

document.addEventListener('DOMContentLoaded', () => {
    const topbar = document.querySelector('.tb');
    const tbBg = document.querySelector('.tb__bg');
    const firstLevelSections = document.querySelectorAll("body > .shopify-section > section");

    if (!topbar || !tbBg) {
        return;
    }
    const dropdownItems = document.querySelectorAll('.tb-item--dropdown');

    if (dropdownItems.length === 0) {
        return;
    }

    if(firstLevelSections.length > 0){
        firstLevelSections.forEach(section => {
            section.addEventListener('click', () => closeTopbar(document.body, dropdownItems));
        })
    }

    tbBg.addEventListener('click', () => closeTopbar(document.body, dropdownItems));
    dropdownItems.forEach(item => {
        const clickableItem = item.querySelector('.tb-item__text');
        if(!clickableItem){
            return;
        }
        clickableItem.addEventListener('click', function(e){
            const isOpen = item.classList.contains('visible');
            closeTopbar(document.body, dropdownItems);
            if (!isOpen) {
                item.classList.add('visible');
                setFullHeight(tbBg);
                document.body.classList.add('topbar-2024');
                e.stopPropagation();
            }
        })
    })
})

const closeTopbar = (body, dropdownItems) => {
    body.classList.remove('topbar-2024');
    dropdownItems.forEach(item => item.classList.remove('visible'));
}